import { render, staticRenderFns } from "./NewApplications.vue?vue&type=template&id=b1792508&scoped=true"
import script from "./NewApplications.vue?vue&type=script&lang=js"
export * from "./NewApplications.vue?vue&type=script&lang=js"
import style0 from "./NewApplications.vue?vue&type=style&index=0&id=b1792508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1792508",
  null
  
)

export default component.exports